import { useCallback, useMemo } from "react";
import { usePopups } from "../../contexts/PopupContext";
import React from "react";

const isPopup = (Component, name) => (props) => {
    const [popups, , , setPopups] = usePopups();
    const options = useMemo(() => popups[name], [popups]);
    const setOptions = useCallback((optionsIn) => {
        if (!name) return;
        const toSave = typeof optionsIn === "function" ? optionsIn(options) : optionsIn;
        setPopups(prev => ({
            ...prev,
            [name]: {
                ...(prev?.[name] || {}),
                ...toSave,
            }
        }));
    }, [setPopups, options]);
    return options?.open ? <Component {...props} options={options} setOptions={setOptions} /> : null;
};

export { isPopup };